const insertItem = (array, index, item) => {
  const firstPart = array.slice(0, index);
  const secondPart = array.slice(index);
  return [...firstPart, item, ...secondPart];
};

export default insertItem;
